import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageHeaderComponent } from '../shared/page-header/page-header.component';
import { SariMetricsComponent } from '../sari-metrics/sari-metrics.component';
import { AwsCostosComponent } from '../aws-costos/aws-costos.component';

@Component({
  selector: 'app-infraestructura-seguimiento',
  standalone: true,
  imports: [CommonModule, PageHeaderComponent, SariMetricsComponent, AwsCostosComponent],
  templateUrl: './infraestructura-seguimiento.component.html',
  styleUrl: './infraestructura-seguimiento.component.css'
})
export class InfraestructuraSeguimientoComponent {
  activeTab: 'metricas' | 'costos' = 'metricas';

  selectTab(tab: 'metricas' | 'costos'): void {
    this.activeTab = tab;
  }
}
